export var IdAssetBundleTournamentTent;
(function (IdAssetBundleTournamentTent) {
    IdAssetBundleTournamentTent["TournamentTent_1"] = "TournamentTent_1";
    IdAssetBundleTournamentTent["TournamentTent_2"] = "TournamentTent_2";
})(IdAssetBundleTournamentTent || (IdAssetBundleTournamentTent = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/outskirts/IdAssetBundleTournamentTent.ts
// module id = 2143
// module chunks = 3